import {DateTime} from "luxon";
import axios from "axios";

const get_contact_center_phone_availability = async function (phone_number_id) {
  if (is_business_hours()) {
    const {data} = await axios.get(`${process.env.VUE_APP_CONTACT_CENTER_URL}/api/phone_numbers/${phone_number_id}`)
    return data;
  }
  return null;
}

const is_business_hours = () => {
  const now = DateTime.now().setZone('America/Chicago');
  const dayOfWeek = now.weekday;
  const currentTime = now.toFormat('HHmm');
  const weekday_range = ['0900', '1730'];
  const saturday_range = ['0930', '1630'];
  return (dayOfWeek >= 1 && dayOfWeek <= 5 && currentTime >= weekday_range[0] && currentTime <= weekday_range[1]) ||
    (dayOfWeek === 6 && currentTime >= saturday_range[0] && currentTime <= saturday_range[1]);
}

export default () => {
  return {
    get_contact_center_phone_availability,
    is_business_hours
  }
}
